import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-router-user-active",
  "use": "icon-router-user-active-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-router-user-active\">\n<g id=\"icon-router-user-active_icon\">\n<path id=\"icon-router-user-active_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0796 12.3558C16.6839 11.443 17.7681 9.70147 17.7681 7.7031C17.7681 4.75885 15.4147 2.37207 12.5117 2.37207C9.6086 2.37207 7.2552 4.75885 7.2552 7.7031C7.2552 9.70148 8.33939 11.443 9.94375 12.3558C6.08448 13.4507 3.21623 16.9523 3.0117 21.1644H4.41363C4.65959 16.818 8.20827 13.4001 12.5117 13.4001C16.8151 13.4001 20.3638 16.818 20.6097 21.1644H22.0117C21.8071 16.9523 18.9389 13.4506 15.0796 12.3558Z\" fill=\"#FEFEFF\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/router-user-active.svg
// module id = e6k+
// module chunks = 102